var is_home_page = false;

if (document.body.classList.contains('home')) {
  is_home_page = true;
}

var homeSolutions;

if (
  is_home_page ||
  document.body.classList.contains('category') ||
  document.body.classList.contains('page-template-page-fake-archive') ||
  document.body.classList.contains('machines')
) {
  homeSolutions = document.getElementsByClassName('fba-solution');

  for (let i = 0; i < homeSolutions.length; i++) {
    homeSolutions[i].addEventListener('mouseenter', function () {
      solutionHover(this, true);
    });
    homeSolutions[i].addEventListener('mouseleave', function () {
      solutionHover(this, false);
    });
  }
}

function solutionHover(target, attr) {
  if (attr) {
    for (let i = 0; i < homeSolutions.length; i++) {
      homeSolutions[i].setAttribute('active', false);
    }

    target.setAttribute('active', true);
  } else {
    for (let i = 0; i < homeSolutions.length; i++) {
      homeSolutions[i].setAttribute('active', 'unset');
    }
  }
}
